/**
 * Environment Configuration
 *
 * Centralized configuration for all environment-specific URLs and settings.
 * Values are loaded from environment variables (.env files).
 */

interface Config {
  // Application Settings
  hostUrl: string;

  // API Endpoints
  lambdaUrl: string;
  modernApiUrl: string;
  legacyExternalUrl: string;
  legacyScribonlineDomain: string;

  // Authentication
  authAuthorityLegacy: string;
  authAuthorityModern: string;
}

const config: Config = {
  // Application host URL (used for OAuth redirects)
  hostUrl: process.env.REACT_APP_HOST_URL || 'http://localhost:3000',

  // AWS Lambda API endpoint (authentication & annotation services)
  lambdaUrl:
    process.env.REACT_APP_LAMBDA_URL ||
    'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development',

  // Modern API (Parchment/Archive)
  modernApiUrl:
    process.env.REACT_APP_MODERN_API_URL ||
    'https://docmanagement.parchment.com/v1/api/archive',

  // Legacy External View URL
  legacyExternalUrl:
    process.env.REACT_APP_LEGACY_EXTERNAL_URL ||
    'https://externalview.scribonline.com',

  // Legacy Scribonline domain (for dynamic client URLs)
  legacyScribonlineDomain:
    process.env.REACT_APP_LEGACY_SCRIBONLINE_DOMAIN || 'scribonline.com',

  // Authentication authorities
  authAuthorityLegacy:
    process.env.REACT_APP_AUTH_AUTHORITY_LEGACY ||
    'https://auth.scribonline.com/development/config/externalview.scribonline.com',

  authAuthorityModern:
    process.env.REACT_APP_AUTH_AUTHORITY_MODERN ||
    'https://docmanagement.parchment.com/v1/api/archive/external/oauth'
};

/**
 * Helper function to build legacy Scribonline URLs with client subdomain
 * @param client - Client subdomain
 * @returns Full URL with client subdomain
 */
export const getLegacyScribonlineUrl = (client: string): string => {
  return `https://${client}.${config.legacyScribonlineDomain}`;
};

/**
 * Helper function to build modern login URL
 * @returns Modern login endpoint
 */
export const getModernLoginUrl = (): string => {
  return `${config.modernApiUrl}/external/login`;
};

/**
 * Helper function to build legacy login URL
 * @returns Legacy login endpoint
 */
export const getLegacyLoginUrl = (): string => {
  return `${config.legacyExternalUrl}/login`;
};

export default config;
